import Modal from 'react-bootstrap/Modal'
import Alert from 'react-bootstrap/Alert'
import Button from 'react-bootstrap/Button'

const TIPO_VIDEO = 'video'
const TIPO_GALERIA = 'galeria'

function EliminarPublicacion(props) {
    const { publicacion, setQueMostrar, eliminar } = props

    const handleClose = () => {
        setQueMostrar('')
    }

    const handleEliminar = () => {
        eliminar(publicacion.id)
    }

    const tipoTexto = publicacion.tipo === TIPO_VIDEO ? 'Video' : 'Galeria'
    const cantidadImagenes = publicacion.imagenes?.length || 0

    return (
        <Modal show={true} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    <i className="fa fa-exclamation-triangle text-danger me-2"></i>
                    Eliminar Publicacion
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Alert variant="danger">
                    <i className="fa fa-trash me-2"></i>
                    Esta a punto de eliminar la publicacion <strong>"{publicacion.titulo}"</strong>.
                    <br />
                    <strong>Esta accion no se puede deshacer.</strong>
                </Alert>

                <p>Esta seguro que desea continuar?</p>

                <div className="bg-light p-3 rounded">
                    <small className="text-muted">
                        <strong>Informacion de la publicacion:</strong>
                        <br />
                        - Tipo: {tipoTexto}
                        <br />
                        - Titulo: {publicacion.titulo}
                        <br />
                        {publicacion.tipo === TIPO_GALERIA && cantidadImagenes > 0 && (
                            <>- Imagenes en galeria: {cantidadImagenes}<br /></>
                        )}
                        - Estado: {(publicacion.borrador === '1' || publicacion.borrador === 1 || publicacion.borrador === true) ? 'Borrador' : 'Publicada'}
                    </small>
                </div>

                {publicacion.tipo === TIPO_GALERIA && cantidadImagenes > 0 && (
                    <Alert variant="warning" className="mt-3 mb-0">
                        <i className="fa fa-images me-2"></i>
                        Se eliminaran tambien las {cantidadImagenes} imagenes de la galeria.
                    </Alert>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-secondary" onClick={handleClose}>
                    <i className="fa fa-times me-1"></i>
                    Cancelar
                </Button>
                <Button variant="danger" onClick={handleEliminar}>
                    <i className="fa fa-trash me-1"></i>
                    Eliminar
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default EliminarPublicacion
